import React, { useState } from "react";
import { Link } from "react-router-dom";
import userIcon from "../../assets/images/icons/userIcon.svg";
import phone from "../../assets/images/icons/phone.svg";
import otpshield from "../../assets/images/icons/otpShiled.svg";
import login_img from "../../assets/images/bg1.jpg";
import ApiConfig from "./../../api/ApiConfig";
import { notifyError, notifySuccess } from "../../sharedComponent/notify";

const Registration = () => {
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [timer, setTimer] = useState(30);
  const [isLoading, setIsLoading] = useState(false);

  // ✅ Replaced handleRequestOtp with your handleClick logic
  const handleRequestOtp = async (e) => {
    e.preventDefault();

    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    let checkIsEmail = false;
    if (emailPattern.test(phoneNumber)) {
      checkIsEmail = true;
      notifyError("Email login coming soon, please try with phone number");
      return;
    }

    const regex = /^\d{10}$/;
    if (fullName.trim() === "") {
      notifyError("Please enter your full name");
      return;
    }

    if (!checkIsEmail && !regex.test(phoneNumber)) {
      notifyError("Invalid phone number or email address");
      return;
    }

    // Construct API request body
    const requestBody = {
      full_name: fullName,
      email: checkIsEmail ? phoneNumber : phoneNumber + "@noreply.com",
      phone_number: checkIsEmail ? "" : "+91" + phoneNumber, // using +91 for India
      Hash: "fygKr7uOg", // default hash from your mobile code
    };

    console.log("URL:", ApiConfig.CREATE_USER);
    console.log("Request Body:", requestBody);

    try {
      setIsLoading(true);

      const response = await fetch(ApiConfig.CREATE_USER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const res = await response.json();
      setIsLoading(false);

      console.log("Response:", res);

      if (res?.success) {
        notifySuccess(res?.message || "OTP sent successfully!");
        setOtp(res?.otp ?? "");
        setIsOtpSent(true);
        startTimer();
      } else {
        notifyError(res?.message || "Failed to send OTP");
      }
    } catch (e) {
      notifyError(e?.message || "Network error while sending OTP");
      setIsLoading(false);
    }
  };

  // Verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!isOtpSent) {
      notifyError("Please request OTP first");
      return;
    }

    if (otp.length < 4) {
      notifyError("Invalid OTP!");
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(ApiConfig.LOGIN_WITH_OTP, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phoneNumber: "+91" + phoneNumber,
          otp: otp,
          full_name: fullName,
        }),
      });

      const result = await response.json();
      if (result.success) {
        notifySuccess("Registration successful!");
        window.location.href = "/";
      } else {
        notifyError(result.message || "Invalid OTP");
      }
    } catch (error) {
      notifyError("Network error while verifying OTP");
    } finally {
      setIsLoading(false);
    }
  };

  // OTP Resend Timer
const startTimer = () => {
  let countdown = 600; // 10 minutes = 600 seconds
  setTimer(countdown);

  const interval = setInterval(() => {
    countdown -= 1;
    setTimer(countdown);

    if (countdown <= 0) {
      clearInterval(interval);
    }
  }, 1000);
};

  return (
    <div className="authMain registrationMain">
      <div className="row">
        <div className="col-md-12 col-lg-6">
          <div className="RegisterForm">
            <div className="belowScroll">
              <h1 className="signInTxt">Sign Up</h1>
              <h6 className="signInPara">
                If you already have an account
                <p className="mt-2 youCan">
                  You can
                  <Link to="/" className="registerLink ms-1">
                    Login Here!
                  </Link>
                </p>
              </h6>

              <form>
                {/* Full Name */}
                <div className="inputBox">
                  <label className="emailLabel">Full Name</label>
                  <img src={userIcon} className="mailImg" alt="" />
                  <input
                    type="text"
                    className="form-control formInput"
                    placeholder="Enter your full name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </div>

                {/* Phone Number */}
                <div className="inputBox">
                  <div className="numberRegistration">
                    <label className="emailLabel">Phone Number</label>
                    {!isOtpSent ? (
                      <button
                        className="requestBtn"
                        onClick={handleRequestOtp}
                        disabled={isLoading}
                      >
                        {isLoading ? "Sending..." : "Request OTP"}
                      </button>
                    ) : (
                      <button
                        className="requestBtn"
                        onClick={handleRequestOtp}
                        disabled={timer > 0}
                      >
                        {timer > 0 ? `Resend in (${timer})` : "Resend OTP"}
                      </button>
                    )}
                  </div>
                  <img src={phone} className="mailImg" alt="" />
                  <input
                    type="text"
                    className="form-control formInput"
                    placeholder="Enter your Phone Number"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>

                {/* OTP Input */}
                {isOtpSent && (
                  <div className="inputBox">
                    <label className="emailLabel">OTP</label>
                    <img src={otpshield} className="mailImg" alt="" />
                    <input
                      type="text"
                      className="form-control formInput"
                      placeholder="Enter OTP here..."
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                )}

                <div className="belowChecks">
                  {/* <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="termsCheck"
                    />
                    <label className="form-check-label checkLbl" htmlFor="termsCheck">
                      <span className="terms">I agree with</span>
                      <Link to="#" className="registerLink ms-1">
                        terms and conditions
                      </Link>
                    </label>
                  </div> */}
                </div>

                {/* Register Button */}
                <div className="login">
                           <Link to="#" className="loginBtn">
                  <button
                    className="loginBtn"
                    onClick={handleVerifyOtp}
                    disabled={isLoading}
                    style={{
                      color:"white"
                    }}
                  >
                    {isLoading ? "Please wait..." : "Register"}
                  </button> 
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="col-md-12 col-lg-6">
          <div className="landingImg">
            <div className="insiderIcon">
              <img src={login_img} alt="" />
            </div>
            <div className="landingTxt">
              <div className="d-flex flex-column justify-content-start">
                <h1>Sign Up to Zamzam App</h1>
                <p>Let's get started!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registration;

